import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { buildRouteChildren } from "./routes";
import { PRESETS_ADMIN_ENABLED } from "./config";
import AutoSignInProvider from "./components/AutoSignInProvider";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Pymble brand theme (shared via pymble-ui) */
import "pymble-ui/theme.css";
import "pymble-ui/components.css";

/* App-specific overrides */
import "./theme/pymble.css";

import "./App.css";

setupIonicReact();

function App() {
  return (
    <IonApp>
      <IonReactRouter basename={"/"}>
        <AutoSignInProvider>
          <IonRouterOutlet id="main" animated={false}>
            {buildRouteChildren(PRESETS_ADMIN_ENABLED)}
          </IonRouterOutlet>
        </AutoSignInProvider>
      </IonReactRouter>
    </IonApp>
  );
}

export default App;
